import LoadingAnimation from "components/LoadingAnimation";
import { UserContext } from "providers/UserProvider";
import { useContext, useEffect } from "react";

export const DefaultRoutes = () => {
  const { getUser, user, loading } = useContext(UserContext);

  useEffect(() => {
    if (user === undefined && !loading) {
      getUser("/logged/dashboard");
    }
  }, [getUser, loading, user]);

  return <LoadingAnimation />;
};
